jQuery(function() {
  'use strict';
  var GOOGLE_MAPS_KEY = 'AIzaSyBLADXcVO6Kd2rH1Ol1Y1WJzgoCugkxT2w';
  var $ = jQuery;
  var maps = $('.paragraph--type--map-element');

  if (!maps.length) {
    return;
  }

  var script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_MAPS_KEY + '&callback=init_google_maps&v=3.34';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
});

function init_google_maps() {
  'use strict';
  var $ = jQuery;
  $('.paragraph--type--map-element').each(function() {
    var map = new google.maps.Map(
      $('.map', this)[0],
      {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        styles: JSON.parse($('.style', this).text().trim() || '[]'),
      }
    );

    var bounds = new google.maps.LatLngBounds();
    // $('.paragraph--type--body-map-marker', this).each(function() {
      var body = $('.marker-body', this).html().trim();
      var p = $('.marker-position', this).text().trim().split(',');
      var lat = parseFloat(p[0]);
      var lng = parseFloat(p[1]);
      var pos = new google.maps.LatLng(lat, lng);

    var image = {
      url: '/themes/theme/img/map_marker_orange.png',
      // size: new google.maps.Size(44, 70),
    };
      var marker = new google.maps.Marker({
        position: pos,
        map: map,
        icon: image,
      });

      if (body) {
        var infowindow = new google.maps.InfoWindow({
          content: body,
        });

        marker.addListener('click', function() {
          infowindow.open(map, marker);
        });
      }

      // console.log(pos);
      bounds.extend(pos);
    // });

    var lat = bounds.getNorthEast().lat();
    var lng = bounds.getNorthEast().lng();
    var padding = 0.002;
    bounds.extend(new google.maps.LatLng(lat + padding, lng + padding));
    bounds.extend(new google.maps.LatLng(lat - padding, lng - padding));

    function resize() {
      map.fitBounds(bounds);
    }
    // window.addEventListener('resize', resize);
    resize();
  });
}
